import { Button, Icon, Typography } from '@smartgift/frontend-toolkit';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '@hero/atoms';

import { UPLOAD_EMAIL_STEPS } from '../../UploadEmailSpreadSheet/constant';

import * as S from './style';

function UploadEmailReviewImport({
  setFooterProps,
  setStep,
  uploadedEmails,
  setUploadedEmails,
  onEmailUpdateDone,
  onRequestClose,
  isPrimaryButtonDisabled
}) {
  const { t } = useTranslation();

  useEffect(() => {
    setFooterProps({
      leftButtonText: t('back'),
      leftButtonOnClick: () => {
        setStep(UPLOAD_EMAIL_STEPS.UPLOAD_SPREADSHEET);
      },
      isLeftButtonActive: true,
      isRightButtonActive:
        uploadedEmails.length > 0 &&
        uploadedEmails.filter(r => r.hasError).length === 0 &&
        !isPrimaryButtonDisabled,
      isRightButtonLoading: isPrimaryButtonDisabled,
      rightButtonOnClick: async () => {
        if (onEmailUpdateDone) await onEmailUpdateDone(uploadedEmails);
        setStep(UPLOAD_EMAIL_STEPS.UPLOAD_SPREADSHEET);
        setUploadedEmails([]);
        onRequestClose();
      },
      rightButtonText: t('importEmails')
    });
  }, [uploadedEmails, onEmailUpdateDone, onEmailUpdateDone]);

  return (
    <S.UploadEmailReviewImport>
      <S.ReviewHead>
        <S.ReviewHeadTitle>
          <Typography variant="body1Bold">{t('reviewAndImport')}</Typography>
          <Typography variant="body2" color="fg" emphasis="weaker">
            {t('reviewAndImportDescriptionEmailUpload')}
          </Typography>
        </S.ReviewHeadTitle>
        <Button
          variant="link"
          color="fg"
          onClick={() => {
            setUploadedEmails([]);
            setStep(UPLOAD_EMAIL_STEPS.UPLOAD_SPREADSHEET);
          }}
        >
          {t('startOver')}
        </Button>
      </S.ReviewHead>
      <Card>
        <S.ResultItem>
          <S.ResultTitle variant="body2">{t('emails')}:</S.ResultTitle>
          <S.ResultBody>
            <S.ResultDescription>
              <b>{uploadedEmails.length}</b> {t('emailsUploadedSuccessfully')}
            </S.ResultDescription>
            <Button
              style={{ color: 'var(--color-accent-secondary-default)' }}
              variant="link"
              color="neutral"
              onClick={() => {
                setStep(UPLOAD_EMAIL_STEPS.UPLOAD_SPREADSHEET);
              }}
            >
              {t('edit')}
            </Button>
          </S.ResultBody>
        </S.ResultItem>
      </Card>

      <S.InfoText>
        <Icon name="info" size="sm" />
        {t('dragAndDropFileInfoEmail')}
      </S.InfoText>
    </S.UploadEmailReviewImport>
  );
}

export { UploadEmailReviewImport };
